/**
 * آدرس صفحه‌ی اصلی مجله؛ روتر با همین مسیر، `HomeBlog` را رندر می‌کند
 * (`src/app/[[...slug]]/page.jsx`).
 */
export const BLOG_HOME_URL = "/blogs";

/**
 * مقصد «بازگشت» وقتی تاریخچه‌ای از همین سایت نیست (ورود مستقیم از گوگل یا لینک):
 * صفحات مجله به خانه‌ی مجله و بقیه به خانه‌ی اصلی (setup_safe_back در LayoutMapping).
 */
export const get_back_fallback_url = (pathname = "") =>
  pathname.startsWith("/blog") ? `${BLOG_HOME_URL}/` : "/";

/**
 * آدرس‌های نیمه‌انکد شده نباید باعث خطا شوند؛ اگر decode نشد، همان مقدار خام
 * بررسی می‌شود.
 */
const decode_url = (url) => {
  try {
    return decodeURIComponent(url);
  } catch {
    return url;
  }
};

/**
 * آدرس آیتم «مجله ژومنت» در منوهای CMS خراب ذخیره شده است و هر سه حالت به
 * صفحه‌ی اشتباه یا ۴۰۴ می‌رسند:
 *   - منوی هدر: `/-blogs`
 *   - نویگیشن موبایل: `/blogs%2Fsearch` (اسلش انکد شده)
 *   - منوی فوتر: `blogs` (بدون اسلش ابتدایی، نسبت به مسیر فعلی باز می‌شود)
 * تا وقتی داده‌ی منو در پنل اصلاح نشده، آدرس را قبل از رندر نرمال می‌کنیم.
 */
const BLOG_URL_PATTERN = /^\/?-*blogs(\/|\?|$)/i;

export const is_blog_menu_url = (url) =>
  typeof url === "string" && BLOG_URL_PATTERN.test(decode_url(url.trim()));

/**
 * مسیر بلاگ را به شکل درست برمی‌گرداند. فقط مسیرهای محتوایی زیر بلاگ (مثل
 * دسته‌بندی یا تک‌مطلب) دست‌نخورده می‌مانند؛ بقیه به صفحه‌ی اصلی مجله می‌روند.
 */
export const normalize_blog_url = (url) => {
  if (typeof url !== "string" || !url.trim()) return BLOG_HOME_URL;

  let path = decode_url(url.trim());

  // `blogs`، `-blogs` و `/-blogs` همگی باید به `/blogs` تبدیل شوند
  path = path.replace(/^\/?-*blogs/i, BLOG_HOME_URL);

  if (!/^\/blogs\//.test(path) || /^\/blogs\/search\/?$/.test(path)) {
    return BLOG_HOME_URL;
  }

  return path;
};

/**
 * آدرس آیتم منو برای رندر: لینک‌های مجله نرمال می‌شوند و بقیه دست‌نخورده
 * می‌مانند.
 */
export const resolve_menu_url = (url, fallback = "") =>
  is_blog_menu_url(url) ? normalize_blog_url(url) : url || fallback;
